export default {
  flipCardButton: {
    frontLabel: 'View card number',
    backLabel: 'Hide card number',
  },
};
